import { IPageSOBP, NeoStroke } from "@neolab-libs/nl-lib3-common";
import { NativeMethods } from "@neolab-libs/nl-lib3-pengateway/src/nl-lib-native-methods/NativeMethods";
import ProjectSubmissionStore from "@stores/ProjectSubmissionStore";


export class USBStrokeUploader {

    private projectCode: string;
    private userCode: string;
    private range: { start: IPageSOBP; end: IPageSOBP };
    private strokes: NeoStroke[];
    private submissionCode?: string;
    private projectSubmissionStore: ProjectSubmissionStore;
    private deviceId: string;
    private fileNames: string[];

    constructor(
        projectCode: string,
        userCode: string,
        range: { start: IPageSOBP; end: IPageSOBP },
        strokes: NeoStroke[],
        submissionCode: string | undefined,
        projectSubmissionStore: ProjectSubmissionStore,
        deviceId: string,
        fileNames: string[]
    ) {
        this.projectCode = projectCode;
        this.userCode = userCode;
        this.range = range;
        this.strokes = strokes;
        this.submissionCode = submissionCode;
        this.projectSubmissionStore = projectSubmissionStore;
        this.deviceId = deviceId;
        this.fileNames = fileNames;
    }

    // Instance function to generate rubric
    async uploadAndDelete() {
        // You can now access instance properties like:
        // this.projectCode, this.userCode, this.range, this.strokes, this.submissionCode, this.projectSubmissionStore
        const code = await this.projectSubmissionStore.uploadAnswerStrokes({
			projectCode: this.projectCode,
			userCode: this.userCode,
			range: this.range,
			strokes: this.strokes,
			submissionCode: this.submissionCode
		});
/*
        if (code) {
            await this.deleteFiles(this.deviceId, this.fileNames);
        }
*/
    }

    private async deleteFiles(deviceId: string, fileNames: string[]) {
        await NativeMethods.deleteFile(deviceId, fileNames);
    }
    
}